import { ROUTES } from "@/constants/Routes";
import { useUserOrganizationStore } from "@/store/useUserOrganizationStore";
import { useUserStore } from "@/store/useUserStore";
import { Box, Grid2, Link, Typography } from "@mui/material";
import { blueGrey } from "@mui/material/colors";

export function OrganizationManagement() {
	const userId = useUserStore((s) => s.id);
	const isResponsible = useUserStore((s) => s.isResponsible);

	const organizationId = useUserOrganizationStore(
		(store) => store.organization?.id
	);

	return (
		<>
			<Typography variant='body2'>
				Uma organização é gerenciada somente por responsáveis da mesma. Esses
				usuários são configurados no momento da criação da organização ou podem
				ter a permissão de administrador posterior definida por outro
				responsável da organização.
			</Typography>

			<Typography variant='body2'>
				Para visualizar e alterar os dados da organização basta acessar a página
				de{" "}
				{userId && isResponsible && organizationId ? (
					<Link href={`${ROUTES.ORGANIZATION.PROFILE}?userId=${userId}`}>
						perfil da organização
					</Link>
				) : (
					"perfil da organização"
				)}
				.
			</Typography>

			<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
				<Typography variant='body2'>
					Um administrador da organização, também chamado de responsável, pode
					alterar os seguintes dados:
				</Typography>

				<Grid2 container spacing={1} rowSpacing={1.5}>
					<Grid2 size={6}>
						<Box>
							<Typography
								variant='body2'
								color={blueGrey[700]}
								fontWeight={600}
								fontSize={"0.85rem"}
							>
								Organização
							</Typography>
							<ul
								style={{
									margin: 0,
									paddingLeft: "1.5rem",
									paddingTop: "0.2rem",
									display: "flex",
									flexDirection: "column",
									gap: 3,
								}}
							>
								<li>
									<Typography variant='body2'>Nome</Typography>
								</li>
								<li>
									<Typography variant='body2'>CEP</Typography>
								</li>
								<li>
									<Typography variant='body2'>Endereço</Typography>
								</li>
								<li>
									<Typography variant='body2'>Cidade</Typography>
								</li>
								<li>
									<Typography variant='body2'>Estado</Typography>
								</li>
							</ul>
						</Box>
					</Grid2>
					<Grid2 size={6}>
						<Box>
							<Typography
								variant='body2'
								color={blueGrey[700]}
								fontWeight={600}
								fontSize={"0.85rem"}
							>
								Pessoal credenciado
							</Typography>
							<ul
								style={{
									margin: 0,
									paddingLeft: "1.5rem",
									paddingTop: "0.2rem",
									display: "flex",
									flexDirection: "column",
									gap: 3,
								}}
							>
								<li>
									<Typography variant='body2'>Adicionar usuário</Typography>
								</li>
								<li>
									<Typography variant='body2'>
										Reativar/Inativar acesso
									</Typography>
								</li>
								<li>
									<Typography variant='body2'>
										Enviar link de redefinição de senha
									</Typography>
								</li>
							</ul>
						</Box>
					</Grid2>
					<Grid2 size={12}>
						<Box>
							<Typography
								variant='body2'
								color={blueGrey[700]}
								fontWeight={600}
								fontSize={"0.85rem"}
							>
								Aplicações
							</Typography>
							<ul
								style={{
									margin: 0,
									paddingLeft: "1.5rem",
									paddingTop: "0.2rem",
									display: "flex",
									flexDirection: "column",
									gap: 3,
								}}
							>
								<li>
									<Typography variant='body2'>Adicionar aplicação</Typography>
								</li>
								<li>
									<Typography variant='body2'>Editar aplicação</Typography>
								</li>
								<li>
									<Typography variant='body2'>
										Responder/Submeter questionários
									</Typography>
								</li>
							</ul>
						</Box>
					</Grid2>
				</Grid2>
			</Box>
		</>
	);
}
